module.exports = __webpack_public_path__ + "img/pr-8.49b71f57.png";